import React from "react";
import { Nav, TabContent } from "reactstrap";
import { compose, withStateHandlers, withHandlers } from "recompose";
import { Page, onMount, NavItem, TabPane } from "components/common";
import { Switch, Redirect } from "react-router-dom";
import TrackingCategoryEdit from "./Edit";
import { Route, Link } from "react-router-dom";
import { Trans } from "react-i18next";
import BackButton from "./../BackButton"

export const TrackingCategoryList = ({
  match,
  categories,
  reloadCategories,
  location,
  ...props
}) => (
  <Page title="" className="inv-tabs">
    <BackButton/>
    <h4 style={{marginTop:"15px",marginBottom:"20px"}}><Trans>Branches & Departments</Trans></h4>
    <Nav tabs>
      {categories.map((i) => (
        <NavItem
          key={i.TrackingCategoryID}
          to={`${match.url}/${i.TrackingCategoryID}`}
        >
          {i.Name}
        </NavItem>
      ))}
      <Route
        path={`${match.url}/new`}
        render={() => <NavItem to={`${match.url}/new`}>Untitled</NavItem>}
      />
    </Nav>
    <TabContent>
      <div className="d-flex justify-content-start">
        <Switch>
          <TabPane
            key={location.pathname}
            path={`${match.url}/:id`}
            render={(props) => (
              <TrackingCategoryEdit {...props} onSaved={reloadCategories} />
              // <h3> Yes</h3>
            )}
          />
          {!!categories.length && (
            <Redirect to={`${match.url}/${categories[0].TrackingCategoryID}`} />
          )}
        </Switch>
      </div>
    </TabContent>
  </Page>
);

export const enhance = compose(
  onMount(
    ({ xero }) =>
      () =>
        Promise.props({
          categories: xero.get("trackingcategories").get("data"),
        })
  ),
  withStateHandlers(
    ({ categories }) => ({
      categories,
    }),
    {
      setCategories: () => (categories) => ({ categories }),
    }
  ),
  withHandlers({
    reloadCategories:
      ({ xero, setCategories }) =>
      () => {
        xero.get("trackingcategories").get("data").then(setCategories);
      },
  })
);

export default enhance(TrackingCategoryList);
